export default {
  sent: 'Faturas enviadas:',
  treatPending: 'Faturas pendentes de tratar',
  sentPending: 'Faturas pendentes de enviar',
  max: 'de máximo',
  barChart: 'Faturas trocadas',
  pieChart: 'Estados das faturas'
}